import {AxiosResponse} from "axios";
import {Yacht} from "@/models/Yacht";
import {ref} from "vue";
import { apiClient } from './client';

const baseUrl = "/luxury";


export const getYachts = (): Promise<AxiosResponse<Yacht[]>> => {
    console.log("client", apiClient.defaults.baseURL); // Debug: Check the baseURL

    return apiClient.get(`${baseUrl}`);
};

export const getYachtBySlug = (slug): Promise<AxiosResponse<Yacht[]>> => {
    console.log("client", apiClient.defaults.baseURL); // Debug: Check the baseURL

    return apiClient.get(`${baseUrl}/${slug}`);
};

// export const getYachts = () => {
//     return Promise.resolve([
//         {
//             name: "Astoria",
//             id: "12314324",
//             slug: "astoria",
//             model: {
//                 id: 1,
//                 name: "Sun Odyssey 440"
//             },
//             category: "MOTOR SAILOR",
//             image: new URL("@/assets/yacht.png", import.meta.url).href,
//             description:"Astoria, this brand new Lagoon 620 – Custom made catamaran, is reserved for those, who want to take their vacation on a very exclusive level. " +
//                 "Luxury and Elegance are the first two words that come into your mind by the first encounter. With a length of 62 ft (18.9 m) and 32.1 ft (9.8 m) width you will " +
//                 "have plenty of room to enjoy the spacious living areas for you and your family and friends. This impressive catamaran is the perfect luxury yacht for a comfortable " +
//                 "and safe cruising through the Greek Islands. Fitting up to 8 guests in 4 Queen size cabins, equipped with separate bathrooms and all stylishly created by Nauta Design " +
//                 "in elegant colours and with an extra emphasis on their functionality, you will feel extra-ordinarily cozy and privileged. The interior of the salon is designed in such " +
//                 "a way that you will feel comfortable and harmonic throughout your journey. Though it will be very difficult for you to part from the beautifully formed aft deck, where " +
//                 "you probably spend most of your time, either being spoiled during breakfast, lunch or dinner, with the delicious culinary delicacies, our chef will prepare especially " +
//                 "for you or just simply relaxing with an aperitif, while gazing at the horizon. At the same time you can choose between sunbathing on comfortable cushions or playing with" +
//                 " dolphins on the spacious foredeck or having a snack and a cocktail, day-dreaming into the sunset, on the elegant fly-bridge. And when the time of the day comes where you " +
//                 "want to practice some fun exercise, there are plenty of amenities make you feel alive and sporty, such as water skiing, knee boarding, wake boarding, paddle boarding or " +
//                 "being towed in a tube. You will feel like having your own private amusement park or you can just take it more relaxed through either snorkeling or fishing or both. When " +
//                 "you read about the crew profile, you will understand that they are carefully chosen, according to their diverse experience and absolute professionalism, their friendly " +
//                 "and attentive character, with which they are going to make your journey the ultimate amazing memory, you are going to hold on to, long after this trip is finished and " +
//                 "intriguing you to plan the next one. However you will want to spend your time on board CARPE DIEM, you can be sure that this vacation you will cherish in your memory " +
//                 "for more than one reason and it will make you want to come back again.",
//             engine: "1x Fischer Panda 10000i PMS 12 Kva, 1x MASE MARINE GENERATOR 26 K, 2x 110 HP VOLVO PENTA",
//             length: 18.87,
//             cabins: 5,
//             berths: 10,
//             heads: 8,
//             crew: 3,
//             lengthOverall: 19.0,
//             beamOverall: 9.8,
//             fuelConsumption: 40,
//             cruisingSpeed: 8,
//             builtYear: 2016,
//             destinations: [
//                 "French Polynesia",
//                 "Fiji Islands",
//                 "South East Asia",
//                 "Indian Ocean",
//                 "Australia",
//             ],
//             price: 38000,
//             tendersToys: [
//                 {
//                     category: "Yacht set up",
//                     tenders: [
//                         "1x12.00m I.C. Yachts Limousine Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "1x12.00m I.C. Yacht Open Sportboat Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "2x6.20m Yachtwerft Meyer Rescue Boat, 6 passengers1x4.11m ICLOYSEA – Custom Carbon Craft-130, 7 passengers",
//                         "2 x F5 SR Seabobs",
//                         "2 x Electric Surfboard - Awake Board - RÄVIK S",
//                         "2 x Electric Foilboard - LIFT eFoil 5.6 cruiser",
//                         "2 x RONIX WAKEBOARDS - Boot Boards Size 144 & 1381 x JOBE VANITY WAKEBOARD SIZE 1312 x Airhead - Combo Water Skis",
//                         "1 x O’Brien - Enforcer Kneeboard1 x Subwing - White Flame Underwater Towing Wing",
//                         "5 x Red Ride Paddle Board - 10’6”2 x Advanced Elements Advanced Frame Expedition EliteInflatable Kayak Blue",
//                         "2 x Deschutes 130 Inflatable Kayak Orange",
//                         "1 x Big Mable Towable",
//                         "1 x Great Big Mable Towable",
//                         "1 x Airhead - Jumbo Dog Towable",
//                         "1 x Demon2 Towables"
//                     ]
//                 },
//                 {
//                     category: "Beach set up",
//                     tenders: [
//                         "2x Custom Carbon Beach Table for up to 6 Guests –Multiplex",
//                         "10x Summit Folding Director's Chair -SD3466x Summit Folding Adjustable Recliner -SD3436x Summit Folding Footrest/Table With Cushion And Tray -SD344",
//                         "2x Beach Parasols -Tuuci Ocean Master M1 Crescent",
//                         "4x Easy Up Platinum 3x3 m Gazebos2x Soundboks Gen.3 Wireless Bluetooth Speakers",
//                         "2x Weber -Summit Kamado E6 Charcoal Grill / BBQSelection of Games & Toys: Beach Volleyball, Cornhole, Cricket, Paddle Tennis, Football, American Football, Disc Golf"
//                     ]
//                 },
//                 {
//                     category: "Gym set up",
//                     tenders: [
//                         "2 X Peloton bikes Various blocks and straps for yoga Full set of dumbbell weights from 2kgs-24kgs Kettlebells 6/8/10/12kgTechnogym: Manual treadmill",
//                         "2 X Normal motorized treadmills2 X Elliptical machines Barbell machine",
//                         "2 X Chest press machine Shoulder press machine Leg extension machine Leg press machine Leg curl machine"
//                     ]
//                 }
//             ]
//         },
//         {
//             name: "Elysian",
//             id: "78967544",
//             slug: "elysian",
//             model: {
//                 id: 2,
//                 name: "Elysian 440"
//             },
//             category: "LUXURY YACHT",
//             image: new URL("@/assets/yacht.png", import.meta.url).href,
//             description:"Elysian, this brand new Lagoon 620 – Custom made catamaran, is reserved for those, who want to take their vacation on a very exclusive level. " +
//                 "Luxury and Elegance are the first two words that come into your mind by the first encounter. With a length of 62 ft (18.9 m) and 32.1 ft (9.8 m) width you will " +
//                 "have plenty of room to enjoy the spacious living areas for you and your family and friends. This impressive catamaran is the perfect luxury yacht for a comfortable " +
//                 "and safe cruising through the Greek Islands. Fitting up to 8 guests in 4 Queen size cabins, equipped with separate bathrooms and all stylishly created by Nauta Design " +
//                 "in elegant colours and with an extra emphasis on their functionality, you will feel extra-ordinarily cozy and privileged. The interior of the salon is designed in such " +
//                 "a way that you will feel comfortable and harmonic throughout your journey. Though it will be very difficult for you to part from the beautifully formed aft deck, where " +
//                 "you probably spend most of your time, either being spoiled during breakfast, lunch or dinner, with the delicious culinary delicacies, our chef will prepare especially " +
//                 "for you or just simply relaxing with an aperitif, while gazing at the horizon. At the same time you can choose between sunbathing on comfortable cushions or playing with" +
//                 " dolphins on the spacious foredeck or having a snack and a cocktail, day-dreaming into the sunset, on the elegant fly-bridge. And when the time of the day comes where you " +
//                 "want to practice some fun exercise, there are plenty of amenities make you feel alive and sporty, such as water skiing, knee boarding, wake boarding, paddle boarding or " +
//                 "being towed in a tube. You will feel like having your own private amusement park or you can just take it more relaxed through either snorkeling or fishing or both. When " +
//                 "you read about the crew profile, you will understand that they are carefully chosen, according to their diverse experience and absolute professionalism, their friendly " +
//                 "and attentive character, with which they are going to make your journey the ultimate amazing memory, you are going to hold on to, long after this trip is finished and " +
//                 "intriguing you to plan the next one. However you will want to spend your time on board CARPE DIEM, you can be sure that this vacation you will cherish in your memory " +
//                 "for more than one reason and it will make you want to come back again.",
//             engine: "1x Fischer Panda 10000i PMS 12 Kva, 1x MASE MARINE GENERATOR 26 K, 2x 110 HP VOLVO PENTA",
//             length: 24.50,
//             cabins: 6,
//             berths: 12,
//             heads: 8,
//             crew: 3,
//             lengthOverall: 19.0,
//             beamOverall: 9.8,
//             fuelConsumption: 40,
//             cruisingSpeed: 8,
//             builtYear: 2016,
//
//             destinations: ["Mediterranean", "Croatia", "Greece", "Italy", "Turkey"],
//             price: 52000,
//             tendersToys: [
//                 {
//                     category: "Yacht set up",
//                     tenders: [
//                         "1x12.00m I.C. Yachts Limousine Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "1x12.00m I.C. Yacht Open Sportboat Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "2x6.20m Yachtwerft Meyer Rescue Boat, 6 passengers1x4.11m ICLOYSEA – Custom Carbon Craft-130, 7 passengers",
//                         "2 x F5 SR Seabobs",
//                         "2 x Electric Surfboard - Awake Board - RÄVIK S",
//                         "2 x Electric Foilboard - LIFT eFoil 5.6 cruiser",
//                         "2 x RONIX WAKEBOARDS - Boot Boards Size 144 & 1381 x JOBE VANITY WAKEBOARD SIZE 1312 x Airhead - Combo Water Skis",
//                         "1 x O’Brien - Enforcer Kneeboard1 x Subwing - White Flame Underwater Towing Wing",
//                         "5 x Red Ride Paddle Board - 10’6”2 x Advanced Elements Advanced Frame Expedition EliteInflatable Kayak Blue",
//                         "2 x Deschutes 130 Inflatable Kayak Orange",
//                         "1 x Big Mable Towable",
//                         "1 x Great Big Mable Towable",
//                         "1 x Airhead - Jumbo Dog Towable",
//                         "1 x Demon2 Towables"
//                     ]
//                 },
//                 {
//                     category: "Beach set up",
//                     tenders: [
//                         "2x Custom Carbon Beach Table for up to 6 Guests –Multiplex",
//                         "10x Summit Folding Director's Chair -SD3466x Summit Folding Adjustable Recliner -SD3436x Summit Folding Footrest/Table With Cushion And Tray -SD344",
//                         "2x Beach Parasols -Tuuci Ocean Master M1 Crescent",
//                         "4x Easy Up Platinum 3x3 m Gazebos2x Soundboks Gen.3 Wireless Bluetooth Speakers",
//                         "2x Weber -Summit Kamado E6 Charcoal Grill / BBQSelection of Games & Toys: Beach Volleyball, Cornhole, Cricket, Paddle Tennis, Football, American Football, Disc Golf"
//                     ]
//                 },
//                 {
//                     category: "Gym set up",
//                     tenders: [
//                         "2 X Peloton bikes Various blocks and straps for yoga Full set of dumbbell weights from 2kgs-24kgs Kettlebells 6/8/10/12kgTechnogym: Manual treadmill",
//                         "2 X Normal motorized treadmills2 X Elliptical machines Barbell machine",
//                         "2 X Chest press machine Shoulder press machine Leg extension machine Leg press machine Leg curl machine"
//                     ]
//                 }
//             ]
//         },
//         {
//             name: "High Five",
//             id: "32487324",
//             slug: "high-five",
//             model: {
//                 id: 3,
//                 name: "Sun Odyssey 440"
//             },
//             category: "LUXURY YACHT",
//             image: new URL("@/assets/yacht.png", import.meta.url).href,
//             description:"High Five, this brand new Lagoon 620 – Custom made catamaran, is reserved for those, who want to take their vacation on a very exclusive level. " +
//                 "Luxury and Elegance are the first two words that come into your mind by the first encounter. With a length of 62 ft (18.9 m) and 32.1 ft (9.8 m) width you will " +
//                 "have plenty of room to enjoy the spacious living areas for you and your family and friends. This impressive catamaran is the perfect luxury yacht for a comfortable " +
//                 "and safe cruising through the Greek Islands. Fitting up to 8 guests in 4 Queen size cabins, equipped with separate bathrooms and all stylishly created by Nauta Design " +
//                 "in elegant colours and with an extra emphasis on their functionality, you will feel extra-ordinarily cozy and privileged. The interior of the salon is designed in such " +
//                 "a way that you will feel comfortable and harmonic throughout your journey. Though it will be very difficult for you to part from the beautifully formed aft deck, where " +
//                 "you probably spend most of your time, either being spoiled during breakfast, lunch or dinner, with the delicious culinary delicacies, our chef will prepare especially " +
//                 "for you or just simply relaxing with an aperitif, while gazing at the horizon. At the same time you can choose between sunbathing on comfortable cushions or playing with" +
//                 " dolphins on the spacious foredeck or having a snack and a cocktail, day-dreaming into the sunset, on the elegant fly-bridge. And when the time of the day comes where you " +
//                 "want to practice some fun exercise, there are plenty of amenities make you feel alive and sporty, such as water skiing, knee boarding, wake boarding, paddle boarding or " +
//                 "being towed in a tube. You will feel like having your own private amusement park or you can just take it more relaxed through either snorkeling or fishing or both. When " +
//                 "you read about the crew profile, you will understand that they are carefully chosen, according to their diverse experience and absolute professionalism, their friendly " +
//                 "and attentive character, with which they are going to make your journey the ultimate amazing memory, you are going to hold on to, long after this trip is finished and " +
//                 "intriguing you to plan the next one. However you will want to spend your time on board CARPE DIEM, you can be sure that this vacation you will cherish in your memory " +
//                 "for more than one reason and it will make you want to come back again.",
//             engine: "1x Fischer Panda 10000i PMS 12 Kva, 1x MASE MARINE GENERATOR 26 K, 2x 110 HP VOLVO PENTA",
//             length: 24.50,
//             cabins: 6,
//             berths: 12,
//             heads: 8,
//             crew: 3,
//             lengthOverall: 19.0,
//             beamOverall: 9.8,
//             fuelConsumption: 40,
//             cruisingSpeed: 8,
//             builtYear: 2016,
//
//             destinations: ["Mediterranean", "Croatia", "Greece", "Italy", "Turkey"],
//             price: 42000,
//             tendersToys: [
//                 {
//                     category: "Yacht set up",
//                     tenders: [
//                         "1x12.00m I.C. Yachts Limousine Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "1x12.00m I.C. Yacht Open Sportboat Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "2x6.20m Yachtwerft Meyer Rescue Boat, 6 passengers1x4.11m ICLOYSEA – Custom Carbon Craft-130, 7 passengers",
//                         "2 x F5 SR Seabobs",
//                         "2 x Electric Surfboard - Awake Board - RÄVIK S",
//                         "2 x Electric Foilboard - LIFT eFoil 5.6 cruiser",
//                         "2 x RONIX WAKEBOARDS - Boot Boards Size 144 & 1381 x JOBE VANITY WAKEBOARD SIZE 1312 x Airhead - Combo Water Skis",
//                         "1 x O’Brien - Enforcer Kneeboard1 x Subwing - White Flame Underwater Towing Wing",
//                         "5 x Red Ride Paddle Board - 10’6”2 x Advanced Elements Advanced Frame Expedition EliteInflatable Kayak Blue",
//                         "2 x Deschutes 130 Inflatable Kayak Orange",
//                         "1 x Big Mable Towable",
//                         "1 x Great Big Mable Towable",
//                         "1 x Airhead - Jumbo Dog Towable",
//                         "1 x Demon2 Towables"
//                     ]
//                 },
//                 {
//                     category: "Beach set up",
//                     tenders: [
//                         "2x Custom Carbon Beach Table for up to 6 Guests –Multiplex",
//                         "10x Summit Folding Director's Chair -SD3466x Summit Folding Adjustable Recliner -SD3436x Summit Folding Footrest/Table With Cushion And Tray -SD344",
//                         "2x Beach Parasols -Tuuci Ocean Master M1 Crescent",
//                         "4x Easy Up Platinum 3x3 m Gazebos2x Soundboks Gen.3 Wireless Bluetooth Speakers",
//                         "2x Weber -Summit Kamado E6 Charcoal Grill / BBQSelection of Games & Toys: Beach Volleyball, Cornhole, Cricket, Paddle Tennis, Football, American Football, Disc Golf"
//                     ]
//                 },
//                 {
//                     category: "Gym set up",
//                     tenders: [
//                         "2 X Peloton bikes Various blocks and straps for yoga Full set of dumbbell weights from 2kgs-24kgs Kettlebells 6/8/10/12kgTechnogym: Manual treadmill",
//                         "2 X Normal motorized treadmills2 X Elliptical machines Barbell machine",
//                         "2 X Chest press machine Shoulder press machine Leg extension machine Leg press machine Leg curl machine"
//                     ]
//                 }
//             ]
//         },
//
//         {
//             name: "White Pearl",
//             id: "8658469",
//             slug: "white-pearl",
//             model: {
//                 id: 4,
//                 name: "Sun Odyssey 440"
//             },
//             category: "SAILING YACHT",
//             image: new URL("@/assets/yacht.png", import.meta.url).href,
//             description:"White Pearl, this brand new Lagoon 620 – Custom made catamaran, is reserved for those, who want to take their vacation on a very exclusive level. " +
//                 "Luxury and Elegance are the first two words that come into your mind by the first encounter. With a length of 62 ft (18.9 m) and 32.1 ft (9.8 m) width you will " +
//                 "have plenty of room to enjoy the spacious living areas for you and your family and friends. This impressive catamaran is the perfect luxury yacht for a comfortable " +
//                 "and safe cruising through the Greek Islands. Fitting up to 8 guests in 4 Queen size cabins, equipped with separate bathrooms and all stylishly created by Nauta Design " +
//                 "in elegant colours and with an extra emphasis on their functionality, you will feel extra-ordinarily cozy and privileged. The interior of the salon is designed in such " +
//                 "a way that you will feel comfortable and harmonic throughout your journey. Though it will be very difficult for you to part from the beautifully formed aft deck, where " +
//                 "you probably spend most of your time, either being spoiled during breakfast, lunch or dinner, with the delicious culinary delicacies, our chef will prepare especially " +
//                 "for you or just simply relaxing with an aperitif, while gazing at the horizon. At the same time you can choose between sunbathing on comfortable cushions or playing with" +
//                 " dolphins on the spacious foredeck or having a snack and a cocktail, day-dreaming into the sunset, on the elegant fly-bridge. And when the time of the day comes where you " +
//                 "want to practice some fun exercise, there are plenty of amenities make you feel alive and sporty, such as water skiing, knee boarding, wake boarding, paddle boarding or " +
//                 "being towed in a tube. You will feel like having your own private amusement park or you can just take it more relaxed through either snorkeling or fishing or both. When " +
//                 "you read about the crew profile, you will understand that they are carefully chosen, according to their diverse experience and absolute professionalism, their friendly " +
//                 "and attentive character, with which they are going to make your journey the ultimate amazing memory, you are going to hold on to, long after this trip is finished and " +
//                 "intriguing you to plan the next one. However you will want to spend your time on board CARPE DIEM, you can be sure that this vacation you will cherish in your memory " +
//                 "for more than one reason and it will make you want to come back again.",
//             engine: "1x Fischer Panda 10000i PMS 12 Kva, 1x MASE MARINE GENERATOR 26 K, 2x 110 HP VOLVO PENTA",
//             length: 30.00,
//             cabins: 4,
//             berths: 8,
//             heads: 8,
//             crew: 3,
//             lengthOverall: 19.0,
//             beamOverall: 9.8,
//             fuelConsumption: 40,
//             cruisingSpeed: 8,
//             builtYear: 2016,
//
//             destinations: ["Caribbean", "Bahamas", "Cuba", "Barbados", "St. Lucia"],
//             price: 44500,
//             tendersToys: [
//                 {
//                     category: "Yacht set up",
//                     tenders: [
//                         "1x12.00m I.C. Yachts Limousine Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "1x12.00m I.C. Yacht Open Sportboat Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "2x6.20m Yachtwerft Meyer Rescue Boat, 6 passengers1x4.11m ICLOYSEA – Custom Carbon Craft-130, 7 passengers",
//                         "2 x F5 SR Seabobs",
//                         "2 x Electric Surfboard - Awake Board - RÄVIK S",
//                         "2 x Electric Foilboard - LIFT eFoil 5.6 cruiser",
//                         "2 x RONIX WAKEBOARDS - Boot Boards Size 144 & 1381 x JOBE VANITY WAKEBOARD SIZE 1312 x Airhead - Combo Water Skis",
//                         "1 x O’Brien - Enforcer Kneeboard1 x Subwing - White Flame Underwater Towing Wing",
//                         "5 x Red Ride Paddle Board - 10’6”2 x Advanced Elements Advanced Frame Expedition EliteInflatable Kayak Blue",
//                         "2 x Deschutes 130 Inflatable Kayak Orange",
//                         "1 x Big Mable Towable",
//                         "1 x Great Big Mable Towable",
//                         "1 x Airhead - Jumbo Dog Towable",
//                         "1 x Demon2 Towables"
//                     ]
//                 },
//                 {
//                     category: "Beach set up",
//                     tenders: [
//                         "2x Custom Carbon Beach Table for up to 6 Guests –Multiplex",
//                         "10x Summit Folding Director's Chair -SD3466x Summit Folding Adjustable Recliner -SD3436x Summit Folding Footrest/Table With Cushion And Tray -SD344",
//                         "2x Beach Parasols -Tuuci Ocean Master M1 Crescent",
//                         "4x Easy Up Platinum 3x3 m Gazebos2x Soundboks Gen.3 Wireless Bluetooth Speakers",
//                         "2x Weber -Summit Kamado E6 Charcoal Grill / BBQSelection of Games & Toys: Beach Volleyball, Cornhole, Cricket, Paddle Tennis, Football, American Football, Disc Golf"
//                     ]
//                 },
//                 {
//                     category: "Gym set up",
//                     tenders: [
//                         "2 X Peloton bikes Various blocks and straps for yoga Full set of dumbbell weights from 2kgs-24kgs Kettlebells 6/8/10/12kgTechnogym: Manual treadmill",
//                         "2 X Normal motorized treadmills2 X Elliptical machines Barbell machine",
//                         "2 X Chest press machine Shoulder press machine Leg extension machine Leg press machine Leg curl machine"
//                     ]
//                 }
//             ]
//         },
//
//
//         {
//             name: "Ocean Pearl",
//             id: "y001",
//             slug: "ocean-pearl",
//             model: {
//                 id: 1,
//                 name: "Sun Odyssey 440"
//             },
//             category: "MOTOR SAILOR",
//             image: new URL("@/assets/yacht.png", import.meta.url).href,
//             description:"Astoria, this brand new Lagoon 620 – Custom made catamaran, is reserved for those, who want to take their vacation on a very exclusive level. " +
//                 "Luxury and Elegance are the first two words that come into your mind by the first encounter. With a length of 62 ft (18.9 m) and 32.1 ft (9.8 m) width you will " +
//                 "have plenty of room to enjoy the spacious living areas for you and your family and friends. This impressive catamaran is the perfect luxury yacht for a comfortable " +
//                 "and safe cruising through the Greek Islands. Fitting up to 8 guests in 4 Queen size cabins, equipped with separate bathrooms and all stylishly created by Nauta Design " +
//                 "in elegant colours and with an extra emphasis on their functionality, you will feel extra-ordinarily cozy and privileged. The interior of the salon is designed in such " +
//                 "a way that you will feel comfortable and harmonic throughout your journey. Though it will be very difficult for you to part from the beautifully formed aft deck, where " +
//                 "you probably spend most of your time, either being spoiled during breakfast, lunch or dinner, with the delicious culinary delicacies, our chef will prepare especially " +
//                 "for you or just simply relaxing with an aperitif, while gazing at the horizon. At the same time you can choose between sunbathing on comfortable cushions or playing with" +
//                 " dolphins on the spacious foredeck or having a snack and a cocktail, day-dreaming into the sunset, on the elegant fly-bridge. And when the time of the day comes where you " +
//                 "want to practice some fun exercise, there are plenty of amenities make you feel alive and sporty, such as water skiing, knee boarding, wake boarding, paddle boarding or " +
//                 "being towed in a tube. You will feel like having your own private amusement park or you can just take it more relaxed through either snorkeling or fishing or both. When " +
//                 "you read about the crew profile, you will understand that they are carefully chosen, according to their diverse experience and absolute professionalism, their friendly " +
//                 "and attentive character, with which they are going to make your journey the ultimate amazing memory, you are going to hold on to, long after this trip is finished and " +
//                 "intriguing you to plan the next one. However you will want to spend your time on board CARPE DIEM, you can be sure that this vacation you will cherish in your memory " +
//                 "for more than one reason and it will make you want to come back again.",
//             engine: "1x Fischer Panda 10000i PMS 12 Kva, 1x MASE MARINE GENERATOR 26 K, 2x 110 HP VOLVO PENTA",
//             length: 18.87,
//             cabins: 5,
//             berths: 10,
//             heads: 8,
//             crew: 3,
//             lengthOverall: 15.0,
//             beamOverall: 9.8,
//             fuelConsumption: 40,
//             cruisingSpeed: 8,
//             builtYear: 2016,
//             destinations: [
//                 "French Polynesia",
//                 "Fiji Islands",
//                 "South East Asia",
//                 "Indian Ocean",
//                 "Australia",
//             ],
//             price: 31000,
//             tendersToys: [
//                 {
//                     category: "Yacht set up",
//                     tenders: [
//                         "1x12.00m I.C. Yachts Limousine Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "1x12.00m I.C. Yacht Open Sportboat Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "2x6.20m Yachtwerft Meyer Rescue Boat, 6 passengers1x4.11m ICLOYSEA – Custom Carbon Craft-130, 7 passengers",
//                         "2 x F5 SR Seabobs",
//                         "2 x Electric Surfboard - Awake Board - RÄVIK S",
//                         "2 x Electric Foilboard - LIFT eFoil 5.6 cruiser",
//                         "2 x RONIX WAKEBOARDS - Boot Boards Size 144 & 1381 x JOBE VANITY WAKEBOARD SIZE 1312 x Airhead - Combo Water Skis",
//                         "1 x O’Brien - Enforcer Kneeboard1 x Subwing - White Flame Underwater Towing Wing",
//                         "5 x Red Ride Paddle Board - 10’6”2 x Advanced Elements Advanced Frame Expedition EliteInflatable Kayak Blue",
//                         "2 x Deschutes 130 Inflatable Kayak Orange",
//                         "1 x Big Mable Towable",
//                         "1 x Great Big Mable Towable",
//                         "1 x Airhead - Jumbo Dog Towable",
//                         "1 x Demon2 Towables"
//                     ]
//                 },
//                 {
//                     category: "Beach set up",
//                     tenders: [
//                         "2x Custom Carbon Beach Table for up to 6 Guests –Multiplex",
//                         "10x Summit Folding Director's Chair -SD3466x Summit Folding Adjustable Recliner -SD3436x Summit Folding Footrest/Table With Cushion And Tray -SD344",
//                         "2x Beach Parasols -Tuuci Ocean Master M1 Crescent",
//                         "4x Easy Up Platinum 3x3 m Gazebos2x Soundboks Gen.3 Wireless Bluetooth Speakers",
//                         "2x Weber -Summit Kamado E6 Charcoal Grill / BBQSelection of Games & Toys: Beach Volleyball, Cornhole, Cricket, Paddle Tennis, Football, American Football, Disc Golf"
//                     ]
//                 },
//                 {
//                     category: "Gym set up",
//                     tenders: [
//                         "2 X Peloton bikes Various blocks and straps for yoga Full set of dumbbell weights from 2kgs-24kgs Kettlebells 6/8/10/12kgTechnogym: Manual treadmill",
//                         "2 X Normal motorized treadmills2 X Elliptical machines Barbell machine",
//                         "2 X Chest press machine Shoulder press machine Leg extension machine Leg press machine Leg curl machine"
//                     ]
//                 }
//             ]
//         },
//         {
//             name: "Sea Whisper",
//             id: "y002",
//             slug: "sea-whisper",
//             model: {
//                 id: 2,
//                 name: "Elysian 440"
//             },
//             category: "LUXURY YACHT",
//             image: new URL("@/assets/yacht.png", import.meta.url).href,
//             description:"Elysian, this brand new Lagoon 620 – Custom made catamaran, is reserved for those, who want to take their vacation on a very exclusive level. " +
//                 "Luxury and Elegance are the first two words that come into your mind by the first encounter. With a length of 62 ft (18.9 m) and 32.1 ft (9.8 m) width you will " +
//                 "have plenty of room to enjoy the spacious living areas for you and your family and friends. This impressive catamaran is the perfect luxury yacht for a comfortable " +
//                 "and safe cruising through the Greek Islands. Fitting up to 8 guests in 4 Queen size cabins, equipped with separate bathrooms and all stylishly created by Nauta Design " +
//                 "in elegant colours and with an extra emphasis on their functionality, you will feel extra-ordinarily cozy and privileged. The interior of the salon is designed in such " +
//                 "a way that you will feel comfortable and harmonic throughout your journey. Though it will be very difficult for you to part from the beautifully formed aft deck, where " +
//                 "you probably spend most of your time, either being spoiled during breakfast, lunch or dinner, with the delicious culinary delicacies, our chef will prepare especially " +
//                 "for you or just simply relaxing with an aperitif, while gazing at the horizon. At the same time you can choose between sunbathing on comfortable cushions or playing with" +
//                 " dolphins on the spacious foredeck or having a snack and a cocktail, day-dreaming into the sunset, on the elegant fly-bridge. And when the time of the day comes where you " +
//                 "want to practice some fun exercise, there are plenty of amenities make you feel alive and sporty, such as water skiing, knee boarding, wake boarding, paddle boarding or " +
//                 "being towed in a tube. You will feel like having your own private amusement park or you can just take it more relaxed through either snorkeling or fishing or both. When " +
//                 "you read about the crew profile, you will understand that they are carefully chosen, according to their diverse experience and absolute professionalism, their friendly " +
//                 "and attentive character, with which they are going to make your journey the ultimate amazing memory, you are going to hold on to, long after this trip is finished and " +
//                 "intriguing you to plan the next one. However you will want to spend your time on board CARPE DIEM, you can be sure that this vacation you will cherish in your memory " +
//                 "for more than one reason and it will make you want to come back again.",
//             engine: "1x Fischer Panda 10000i PMS 12 Kva, 1x MASE MARINE GENERATOR 26 K, 2x 110 HP VOLVO PENTA",
//             length: 24.50,
//             cabins: 6,
//             berths: 12,
//             heads: 8,
//             crew: 3,
//             lengthOverall: 19.0,
//             beamOverall: 9.8,
//             fuelConsumption: 40,
//             cruisingSpeed: 8,
//             builtYear: 2016,
//
//             destinations: ["Mediterranean", "Croatia", "Greece", "Italy", "Turkey"],
//             price: 25000,
//             tendersToys: [
//                 {
//                     category: "Yacht set up",
//                     tenders: [
//                         "1x12.00m I.C. Yachts Limousine Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "1x12.00m I.C. Yacht Open Sportboat Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "2x6.20m Yachtwerft Meyer Rescue Boat, 6 passengers1x4.11m ICLOYSEA – Custom Carbon Craft-130, 7 passengers",
//                         "2 x F5 SR Seabobs",
//                         "2 x Electric Surfboard - Awake Board - RÄVIK S",
//                         "2 x Electric Foilboard - LIFT eFoil 5.6 cruiser",
//                         "2 x RONIX WAKEBOARDS - Boot Boards Size 144 & 1381 x JOBE VANITY WAKEBOARD SIZE 1312 x Airhead - Combo Water Skis",
//                         "1 x O’Brien - Enforcer Kneeboard1 x Subwing - White Flame Underwater Towing Wing",
//                         "5 x Red Ride Paddle Board - 10’6”2 x Advanced Elements Advanced Frame Expedition EliteInflatable Kayak Blue",
//                         "2 x Deschutes 130 Inflatable Kayak Orange",
//                         "1 x Big Mable Towable",
//                         "1 x Great Big Mable Towable",
//                         "1 x Airhead - Jumbo Dog Towable",
//                         "1 x Demon2 Towables"
//                     ]
//                 },
//                 {
//                     category: "Beach set up",
//                     tenders: [
//                         "2x Custom Carbon Beach Table for up to 6 Guests –Multiplex",
//                         "10x Summit Folding Director's Chair -SD3466x Summit Folding Adjustable Recliner -SD3436x Summit Folding Footrest/Table With Cushion And Tray -SD344",
//                         "2x Beach Parasols -Tuuci Ocean Master M1 Crescent",
//                         "4x Easy Up Platinum 3x3 m Gazebos2x Soundboks Gen.3 Wireless Bluetooth Speakers",
//                         "2x Weber -Summit Kamado E6 Charcoal Grill / BBQSelection of Games & Toys: Beach Volleyball, Cornhole, Cricket, Paddle Tennis, Football, American Football, Disc Golf"
//                     ]
//                 },
//                 {
//                     category: "Gym set up",
//                     tenders: [
//                         "2 X Peloton bikes Various blocks and straps for yoga Full set of dumbbell weights from 2kgs-24kgs Kettlebells 6/8/10/12kgTechnogym: Manual treadmill",
//                         "2 X Normal motorized treadmills2 X Elliptical machines Barbell machine",
//                         "2 X Chest press machine Shoulder press machine Leg extension machine Leg press machine Leg curl machine"
//                     ]
//                 }
//             ]
//         },
//         {
//             name: "Azure Dream",
//             id: "y003",
//             slug: "azure-dream",
//             model: {
//                 id: 3,
//                 name: "Sun Odyssey 440"
//             },
//             category: "LUXURY YACHT",
//             image: new URL("@/assets/yacht.png", import.meta.url).href,
//             description:"High Five, this brand new Lagoon 620 – Custom made catamaran, is reserved for those, who want to take their vacation on a very exclusive level. " +
//                 "Luxury and Elegance are the first two words that come into your mind by the first encounter. With a length of 62 ft (18.9 m) and 32.1 ft (9.8 m) width you will " +
//                 "have plenty of room to enjoy the spacious living areas for you and your family and friends. This impressive catamaran is the perfect luxury yacht for a comfortable " +
//                 "and safe cruising through the Greek Islands. Fitting up to 8 guests in 4 Queen size cabins, equipped with separate bathrooms and all stylishly created by Nauta Design " +
//                 "in elegant colours and with an extra emphasis on their functionality, you will feel extra-ordinarily cozy and privileged. The interior of the salon is designed in such " +
//                 "a way that you will feel comfortable and harmonic throughout your journey. Though it will be very difficult for you to part from the beautifully formed aft deck, where " +
//                 "you probably spend most of your time, either being spoiled during breakfast, lunch or dinner, with the delicious culinary delicacies, our chef will prepare especially " +
//                 "for you or just simply relaxing with an aperitif, while gazing at the horizon. At the same time you can choose between sunbathing on comfortable cushions or playing with" +
//                 " dolphins on the spacious foredeck or having a snack and a cocktail, day-dreaming into the sunset, on the elegant fly-bridge. And when the time of the day comes where you " +
//                 "want to practice some fun exercise, there are plenty of amenities make you feel alive and sporty, such as water skiing, knee boarding, wake boarding, paddle boarding or " +
//                 "being towed in a tube. You will feel like having your own private amusement park or you can just take it more relaxed through either snorkeling or fishing or both. When " +
//                 "you read about the crew profile, you will understand that they are carefully chosen, according to their diverse experience and absolute professionalism, their friendly " +
//                 "and attentive character, with which they are going to make your journey the ultimate amazing memory, you are going to hold on to, long after this trip is finished and " +
//                 "intriguing you to plan the next one. However you will want to spend your time on board CARPE DIEM, you can be sure that this vacation you will cherish in your memory " +
//                 "for more than one reason and it will make you want to come back again.",
//             engine: "1x Fischer Panda 10000i PMS 12 Kva, 1x MASE MARINE GENERATOR 26 K, 2x 110 HP VOLVO PENTA",
//             length: 24.50,
//             cabins: 6,
//             berths: 12,
//             heads: 8,
//             crew: 3,
//             lengthOverall: 19.0,
//             beamOverall: 9.8,
//             fuelConsumption: 40,
//             cruisingSpeed: 8,
//             builtYear: 2016,
//
//             destinations: ["Mediterranean", "Croatia", "Greece", "Italy", "Turkey"],
//             price: 52000,
//             tendersToys: [
//                 {
//                     category: "Yacht set up",
//                     tenders: [
//                         "1x12.00m I.C. Yachts Limousine Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "1x12.00m I.C. Yacht Open Sportboat Tender, 16 passengers – Separate Registration with Marshall Islands",
//                         "2x6.20m Yachtwerft Meyer Rescue Boat, 6 passengers1x4.11m ICLOYSEA – Custom Carbon Craft-130, 7 passengers",
//                         "2 x F5 SR Seabobs",
//                         "2 x Electric Surfboard - Awake Board - RÄVIK S",
//                         "2 x Electric Foilboard - LIFT eFoil 5.6 cruiser",
//                         "2 x RONIX WAKEBOARDS - Boot Boards Size 144 & 1381 x JOBE VANITY WAKEBOARD SIZE 1312 x Airhead - Combo Water Skis",
//                         "1 x O’Brien - Enforcer Kneeboard1 x Subwing - White Flame Underwater Towing Wing",
//                         "5 x Red Ride Paddle Board - 10’6”2 x Advanced Elements Advanced Frame Expedition EliteInflatable Kayak Blue",
//                         "2 x Deschutes 130 Inflatable Kayak Orange",
//                         "1 x Big Mable Towable",
//                         "1 x Great Big Mable Towable",
//                         "1 x Airhead - Jumbo Dog Towable",
//                         "1 x Demon2 Towables"
//                     ]
//                 },
//                 {
//                     category: "Beach set up",
//                     tenders: [
//                         "2x Custom Carbon Beach Table for up to 6 Guests –Multiplex",
//                         "10x Summit Folding Director's Chair -SD3466x Summit Folding Adjustable Recliner -SD3436x Summit Folding Footrest/Table With Cushion And Tray -SD344",
//                         "2x Beach Parasols -Tuuci Ocean Master M1 Crescent",
//                         "4x Easy Up Platinum 3x3 m Gazebos2x Soundboks Gen.3 Wireless Bluetooth Speakers",
//                         "2x Weber -Summit Kamado E6 Charcoal Grill / BBQSelection of Games & Toys: Beach Volleyball, Cornhole, Cricket, Paddle Tennis, Football, American Football, Disc Golf"
//                     ]
//                 },
//                 {
//                     category: "Gym set up",
//                     tenders: [
//                         "2 X Peloton bikes Various blocks and straps for yoga Full set of dumbbell weights from 2kgs-24kgs Kettlebells 6/8/10/12kgTechnogym: Manual treadmill",
//                         "2 X Normal motorized treadmills2 X Elliptical machines Barbell machine",
//                         "2 X Chest press machine Shoulder press machine Leg extension machine Leg press machine Leg curl machine"
//                     ]
//                 }
//             ]
//         },
//     ]);
// };


export const getFeaturedYachts = () => {
    return Promise.resolve([
        {
            name: "Astoria",
            id: "12314324",
            slug: "astoria",
            category: "MOTOR SAILOR",
            image: new URL("@/assets/yacht.png", import.meta.url).href,
            length: 18.87,
            cabins: 5,
            berths: 10,
            destinations: [
                "French Polynesia",
                "Fiji Islands",
                "South East Asia",
                "Indian Ocean",
                "Australia",
            ],
            price: 38000,
        },
        {
            name: "Elysian",
            id: "78967544",
            slug: "elysian",
            category: "LUXURY YACHT",
            image: new URL("@/assets/yacht.png", import.meta.url).href,
            length: 24.50,
            cabins: 6,
            berths: 12,
            destinations: ["Mediterranean", "Croatia", "Greece", "Italy", "Turkey"],
            price: 52000,
        },
        {
            name: "High Five",
            id: "32487324",
            slug: "high-five",
            category: "LUXURY YACHT",
            image: new URL("@/assets/yacht.png", import.meta.url).href,
            length: 24.50,
            cabins: 6,
            berths: 12,
            destinations: ["Mediterranean", "Croatia", "Greece", "Italy", "Turkey"],
            price: 42000,
        },

        {
            name: "White Pearl",
            id: "8658469",
            slug: "white-pearl",
            category: "SAILING YACHT",
            image: new URL("@/assets/yacht.png", import.meta.url).href,
            length: 30.00,
            cabins: 4,
            berths: 8,
            destinations: ["Caribbean", "Bahamas", "Cuba", "Barbados", "St. Lucia"],
            price: 44500,
        }
    ])
}



export const getYacht = () => {
    return Promise.resolve([
        {
            name: "Astoria",
            id: "12314324",
            slug: "astoria",
            category: "MOTOR SAILOR",
            image: new URL("@/assets/yacht.png", import.meta.url).href,
            length: 18.87,
            cabins: 5,
            berths: 10,
            destinations: [
                "French Polynesia",
                "Fiji Islands",
                "South East Asia",
                "Indian Ocean",
                "Australia",
            ],
            price: 38000
        }
    ])
}
